import { StorageManager } from './storageManager';

interface GameRecord {
  date: string;
  score: number;
  averageYearsOff: number;
  completionDate: string;
  correctGuesses: number;
}

export const cleanupHighScores = () => {
  // Get game history to fix individual games
  const history = StorageManager.getGameHistory();
  let totalPoints = 0;
  let totalGames = 0;
  let maxScore = 0;
  let totalCorrectGuesses = 0;
  let totalYearsOff = 0;
  let scoresAdjusted = 0;

  // Process each game in history
  const updatedHistory = history.map((game: GameRecord) => {
    if (game.score > 5000) {
      // Cut scores above 5000 in half
      game.score = Math.round(game.score / 2);
      scoresAdjusted++;
    }

    totalPoints += game.score;
    totalGames++;
    maxScore = Math.max(maxScore, game.score);
    totalCorrectGuesses += game.correctGuesses || 0;
    totalYearsOff += game.averageYearsOff || 0;

    return game;
  });

  // Update stats object
  const updatedStats = {
    gamesPlayed: totalGames,
    averageScore: Math.round(totalPoints / totalGames),
    highScore: maxScore,
    totalCorrectGuesses: totalCorrectGuesses,
    averageYearsOff: totalYearsOff / totalGames,
    lifetimePoints: totalPoints,
  };

  // Save updated history and stats
  localStorage.setItem(
    StorageManager.KEYS.GAME_HISTORY,
    JSON.stringify(updatedHistory)
  );
  localStorage.setItem(
    StorageManager.KEYS.USER_STATS,
    JSON.stringify(updatedStats)
  );

  return {
    gamesFixed: updatedHistory.length,
    scoresAdjusted,
    newStats: updatedStats,
  };
};
